import { ICompileService } from "angular";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../records/grids/columns/columnDefinitionService";
import {
  GridSettingsService,
  vsName as GridSettingsServiceName,
} from "../../../records/grids/settings/gridSettingsService";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../records/server/serverUtility";
import {
  GridConfiguration,
  RecordGridViewServiceProvider,
  vsProviderName as RecordGridViewServiceProviderName,
} from "../../../records/views/recordGridView";
import {
  moneyValueGetterFactory,
  percentageValueGetterFactory,
} from "../../../records/grids/cells/valueGetters";

import { machineConfigurationObjectName } from "../../shared/names";
import {
  ColumnDefinitionSetService,
  vsServiceName as ColumnDefinitionSetServiceName,
  ColumnDefinitionSetServiceProvider,
  vsProviderName as ColumnDefinitionSetServiceProviderName,
} from "../../../records/grids/columns/columnDefinitionSetService";
import { RecordDataSource } from "../../../records/grids";
import { defaultSort } from "./machineConfiguration";

MachineGameConfiguration.$inject = [
  RecordGridViewServiceProviderName,
  ColumnDefinitionSetServiceProviderName,
];

export const vsObjectName = "machineGameConfiguration";

export function MachineGameConfiguration(
  recordGridViewServiceProvider: RecordGridViewServiceProvider,
  columnDefinitionSetServiceProvider: ColumnDefinitionSetServiceProvider
) {
  columnDefinitionSetServiceProvider.addColumnDefinitionSet(vsObjectName, [
    ColumnDefinitionSetServiceName,
    ColumnDefinitionServiceName,
    (
      columnDefinitionSetService: ColumnDefinitionSetService,
      columnDefinitionService: ColumnDefinitionService
    ) => [
      ...columnDefinitionSetService.getColumnDefinitionSet(
        machineConfigurationObjectName
      ),
      columnDefinitionService.getStringColDef({
        field: "MachineThemeName",
        header: "Theme",
      }),
      columnDefinitionService.getStringColDef({
        field: "MachineDenominationName",
        header: "Denomination",
      }),
      columnDefinitionService.getNumberColDef({
        field: "MachineDenominationValue",
        header: "Denomination Value",
        hide: true,
      }),
      columnDefinitionService.getStringColDef({
        field: "Reels",
        hide: true,
      }),
      columnDefinitionService.getStringColDef({
        field: "Paylines",
        hide: true,
      }),
      columnDefinitionService.getNumberColDef({
        field: "MaxCreditBet",
        hide: true,
      }),
      columnDefinitionService.getNumberColDef({
        field: "GameHoldPercentage",
        hide: true,
        valueGetter: percentageValueGetterFactory({ decimalPlaces: 2 }),
      }),
      columnDefinitionService.getStringColDef({
        field: "PaytableId",
        hide: true,
      }),
      columnDefinitionService.getNumberColDef({
        field: "MinPaybackPercentage",
        hide: true,
        valueGetter: percentageValueGetterFactory({ decimalPlaces: 2 }),
      }),
      columnDefinitionService.getNumberColDef({
        field: "MaxPaybackPercentage",
        hide: true,
        valueGetter: percentageValueGetterFactory({ decimalPlaces: 2 }),
      }),
      columnDefinitionService.getNumberColDef({
        field: "MaxPaybackWithContribution",
        hide: true,
        valueGetter: percentageValueGetterFactory({ decimalPlaces: 2 }),
      }),
      columnDefinitionService.getNumberColDef({
        field: "MinCreditsBet",
        hide: true,
      }),
      columnDefinitionService.getNumberColDef({
        field: "TopCreditsAward",
        hide: true,
      }),
      columnDefinitionService.getNumberColDef({
        field: "TopDollarAward",
        hide: true,
        valueGetter: moneyValueGetterFactory({ decimalPlaces: 2 }),
      }),
      columnDefinitionService.getNumberColDef({
        field: "Volatility",
        hide: true,
      }),
      columnDefinitionService.getStringColDef({
        field: "GameProgramNumber",
        hide: true,
      }),
      columnDefinitionService.getStringColDef({
        field: "GameProgramVersion",
        hide: true,
      }),
    ],
  ]);

  recordGridViewServiceProvider.addGridConfiguration(vsObjectName, [
    ServerUtilityName,
    GridSettingsServiceName,
    ColumnDefinitionServiceName,
    ColumnDefinitionSetServiceName,
    "$compile",
    (
      serverUtility: ServerUtility,
      gridSettingsService: GridSettingsService
    ) => {
      const gridSettings = gridSettingsService.getGridSettings(
        Symbol("main.machineGameConfiguration.grid")
      );
      const gridConfiguration: GridConfiguration = {
        columnDefinitionSet: vsObjectName,
        defaultSort: `${defaultSort},Order`,
        nameSingular: "Game Configuration",
        namePlural: "Game Configurations",
        gridDataSource: new RecordDataSource(
          serverUtility,
          "/api/machines/MachineGameConfiguration"
        ),
        showAddButton: false,
        gridSettings,
      };

      return gridConfiguration;
    },
  ]);
}
